import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";

import { CheckMark } from "@/assets/icons";
import { generateValidClassNameHandler } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({
    className,
    ...props
}, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={generateValidClassNameHandler(
            "size-4 shrink-0 rounded text-secondary disabled:cursor-not-allowed disabled:opacity-50 bg-gray-300 data-[state=checked]:border border-none data-[state=checked]:bg-primary",
            className,
        )}
        {...props}
    >
        <CheckboxPrimitive.Indicator className={generateValidClassNameHandler("flex items-center justify-center text-current")}>
            <CheckMark
                className="text-background"
                size={12}
            />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
